import { useQuery } from '@tanstack/react-query';

import { useApi } from 'services/api';

const useGetSensorConfiguration = ({ tenantId, sensorId }) => {
  const api = useApi();

  return useQuery({
    queryKey: ['tenants', +tenantId, 'smf', 'sensors', +sensorId, 'configuration'],

    queryFn: () => api.get(`/tenants/${tenantId}/smf/sensors/${sensorId}/configuration`),
  });
};

export default useGetSensorConfiguration;
